type FormatDateOptions = { includeTime?: boolean };

export const formatDate = (
  value: Date | string | null | undefined,
  options?: FormatDateOptions,
): string => {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.valueOf())) return '';
  if (options?.includeTime) {
    return date.toLocaleString();
  }
  return date.toLocaleDateString();
};
